const ACTION_GET_ELECTRIC_METER_DETAIL = 'ACTION_GET_ELECTRIC_METER_DETAIL'
const ACTION_GET_ELECTRIC_METER_DETAIL_SUCCESS = 'ACTION_GET_ELECTRIC_METER_DETAIL_SUCCESS'

export { ACTION_GET_ELECTRIC_METER_DETAIL, ACTION_GET_ELECTRIC_METER_DETAIL_SUCCESS }
